export const Research = [
    // {
    //     id: 'r1',
    //     type: 'research',
    //     name: 'Your Paper Title',
    //     description: 'Short abstract or summary of the work.',
    //     tags: ['NLP', 'LowResource'],
    //     image: '/images/research/paper1.png',
    //     venue: 'Conference / Journal / Preprint',
    //     year: 2025,
    //     status: 'Published', // 'Published' | 'Preprint' | 'In Progress'
    //     paper: 'https://...',    // optional
    //     pdf: 'https://...',      // optional
    //     code: 'https://...',     // optional
    //     dataset: 'https://...',  // optional
    // },

    {
        id: 'r1',
        type: 'research',
        name: 'Aritificial Intelligence Powered Automation for Efficient Workflow Management',
        description: 'This research explores the integration of artificial intelligence (AI) into workflow management systems to enhance efficiency and productivity.',
        tags: ['AI', 'Automation', 'Workflow Management', 'Machine Learning'],
        image: '/images/research/paper1.png',
        venue: 'Journal ',
        year: 2025,
        status: 'Draft', // 'Published' | 'Preprint' | 'In Progress'
        paper: 'https://...',    // optional
        pdf: 'https://...',      // optional
        code: 'https://...',     // optional
        dataset: 'https://...',  // optional
    },
];